document.querySelector('#checkout')?.addEventListener('click', function () {
    setTimeout(() => {
        const modal = document.querySelector('.modalWarningQI');
        const isModalVisible = modal && modal.style.display === 'block';

        if (isModalVisible) {
            document.querySelector('.cart-drawer__close-button')?.click();
        }
    }, 300);
});
